import { HIDDEN_COLUMNS } from '../constant/constants';
import { Column } from '../enum/Column';

/**
 * Filters out columns that should not be displayed on the frontend.
 *
 * A column is included only if:
 *  - its name is not listed in `HIDDEN_COLUMNS`
 *  - it is not explicitly marked as invisible (`isVisible === false`)
 *
 * @param columns - The full list of column definitions returned from the backend.
 * @returns A list of columns that are allowed to be displayed on the frontend.
 */

export function filterVisibleColumns(columns: Column[]): Column[] {
  return columns.filter((col) => !HIDDEN_COLUMNS.includes(col.name) && col.isVisible !== false);
}
